import { Canvas } from 'fabric/fabric-impl';
import { useEffect, useState } from 'react';

import styles from './ToolSelection.module.less';

import textIcon from '../../assets/images/icons/icon_texto.svg';
import textSelectedIcon from '../../assets/images/icons/icon_texto_selected.svg';

import ButtonTool from '../UI/ButtonTool';
import { KEY_TEXT_TOOL_OPTION } from '../../constants';
import { EditorStore, useStore } from '../../store/createStore';
import { CanvasHandler } from '../../handlers/CanvasHandler';

interface ToolSelectionI {
  toolsSelection: ToolSelection[];
  onActiveSelectedTool: (keyTool: string) => void;
}

function ToolSelection(props: ToolSelectionI) {
  const [firstToolRef, setFirstToolRef] = useState(null);
  const setTourStepRef = useStore<EditorStore, any>('tourStepsRef')[1];
  const [dragMode, setDragMode] = useStore<EditorStore, boolean>('dragMode');
  const canvas = useStore<EditorStore, Canvas>('canvas')[0];
  const activeObjectIText = useStore<EditorStore, Canvas>('activeObjectIText')[0];
  const [prevSelectedTool, setPrevSelectedTool] = useStore<EditorStore, string>('prevSelectedTool');
  const [selectedButton, setSelectedButton] = useState('');
  const isSelectedText = selectedButton === KEY_TEXT_TOOL_OPTION;
  const canvasHandler = new CanvasHandler(canvas);

  useEffect(() => {
    if (!firstToolRef) {
      return;
    }
    handleTourStepRef(firstToolRef, 0);
  }, [firstToolRef]);

  useEffect(() => {
    if (!activeObjectIText) {
      return;
    }

    setSelectedButton(KEY_TEXT_TOOL_OPTION);
    props.onActiveSelectedTool(KEY_TEXT_TOOL_OPTION);
    setPrevSelectedTool(KEY_TEXT_TOOL_OPTION);
  }, [activeObjectIText]);

  const handleSelectButton = (selectedButton: string) => {
    return () => {
      setSelectedButton(selectedButton);
      props.onActiveSelectedTool(selectedButton);
      setPrevSelectedTool(selectedButton);
    };
  };

  const handleTourStepRef = (value: HTMLElement, index: number) => {
    setTourStepRef((state: any[]) => {
      const oldStep = state[index];
      const newStep = { ...oldStep, ref: value };
      const filterState = state.filter((item) => item.index !== index);
      return [...filterState, newStep].sort((a, b) => a.index - b.index);
    });
  };

  return (
    <div className="w-full bg-secondary flex justify-center gap-x-2 sm:gap-x-0 absolute bottom-0 z-50" style={{ height: `12%` }}>
      {props.toolsSelection.map((tool, index) => {
        const isSelected = selectedButton === tool.key;
        return (
          <ButtonTool
            ref={index === 0 ? setFirstToolRef : null}
            responsive={true}
            key={tool.key}
            icon={isSelected ? tool.selectedIcon : tool.icon}
            name={tool.name}
            isSelected={isSelected}
            onClick={
              selectedButton === tool.key ? handleSelectButton('') : handleSelectButton(tool.key)
            }
          />
        );
      })}
      <ButtonTool
        icon={isSelectedText ? textSelectedIcon : textIcon}
        responsive={true}
        name="Texto"
        isSelected={isSelectedText}
        onClick={
          selectedButton === KEY_TEXT_TOOL_OPTION
            ? handleSelectButton('')
            : handleSelectButton(KEY_TEXT_TOOL_OPTION)
        }
      />
    </div>
  );
}

export default ToolSelection;
